import React from 'react';
import { applyVisibilityRule, StateProperty, StateVisibilityRule } from '@app/common';
import { useAppSelector } from '../../../store/hooks';
import Modal from '../../molecules/Modal';
import SlotDropdownItemStartButton from '../Modules/Slots/SlotDropdownItemStartButton';

type Properties = {
    currentSectionRecommdation: StateVisibilityRule | undefined;
    setTransientStateProperties: (properties: StateProperty[]) => void;
};

const PickSessionPropertyModal = (props: Properties) => {
    const { currentSectionRecommdation } = props;
    const [pickProperties, setPickProperties] = React.useState<boolean>(false);
    const stateProperties = useAppSelector(state => state.globalState.user?.stateProperties || []);

    React.useEffect(() => {
        if (!currentSectionRecommdation) {
            setPickProperties(true);  // no recommendation specified -> section is visible for both properties
        } else {
            if (applyVisibilityRule(currentSectionRecommdation, ['PREGNANCY']) && !applyVisibilityRule(currentSectionRecommdation, ['POSTPARTUM'])) {
                props.setTransientStateProperties(['PREGNANCY']);
            } else if (!applyVisibilityRule(currentSectionRecommdation, ['PREGNANCY']) && applyVisibilityRule(currentSectionRecommdation, ['POSTPARTUM'])) {
                props.setTransientStateProperties(['POSTPARTUM']);
            } else {
                setPickProperties(true);
            }
        }
    }, [currentSectionRecommdation]);

    const pregnancyRecommended = stateProperties.includes('PREGNANCY');
    const postpartumRecommended = stateProperties.includes('POSTPARTUM');

    if (pickProperties) {
        return <Modal>
            <div className="pick-session-property-modal">
                <div>
                    <h3>
                        Variante der Übung wählen:
                    </h3>
                </div>
                <div className="pick-session-property-modal-button-bar">
                <SlotDropdownItemStartButton
                    isRecommended={pregnancyRecommended}
                    imagePath={'i-pregno/pregnant-less-intense-with-baby.png'}
                    onClick={() => props.setTransientStateProperties(['PREGNANCY'])}
                    isHidden={false}
                />
                <SlotDropdownItemStartButton
                    isRecommended={postpartumRecommended}
                    imagePath={'i-pregno/baby-boy.png'}
                    onClick={() => props.setTransientStateProperties(['POSTPARTUM'])}
                    isHidden={false}
                />
                </div>
            </div>
        </Modal>;
    } else {
        return <div>
            laden...
        </div>;
    }
};

export default PickSessionPropertyModal;
